"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  text-align: center;\n  margin: ", " 0;\n  svg {\n    width: ", ";\n    height: ", ";\n    margin: 0 0 ", " 0;\n    opacity: 0.25;\n    display: block;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoMore = void 0;

var lib_1 = require("@ant-design/icons/lib");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Typography_1 = require("./Typography");

var Container = styled_components_1["default"].div(_templateObject(), function (props) {
  return props.theme[props.isCompact ? '@size-s' : '@size-m'];
}, function (props) {
  return props.theme['@size-l'];
}, function (props) {
  return props.theme['@size-l'];
}, function (props) {
  return props.theme['@size-s'];
});

var NoMore = function NoMore(_ref) {
  var isCompact = _ref.isCompact;

  if (isCompact) {
    return react_1["default"].createElement(Container, null, "No more results!");
  } else {
    return react_1["default"].createElement(Container, null, react_1["default"].createElement(lib_1.ExclamationCircleFilled, null), react_1["default"].createElement(Typography_1.Body, null, "No more results!"));
  }
};

exports.NoMore = NoMore;